import { formatCommaZeroDp, workloadPerc } from "./dataHelpers/formatters";

export const TOOLTIP_SCHEMA = [
  {
    label: true,
    accessor: "name",
  },
  {
    fieldName: "Court",
    accessor: "court",
  },
  {
    fieldName: "Workload score",
    accessor: "workload",
    formatter: formatCommaZeroDp,
  },
  {
    fieldName: "Variance",
    hideFieldName: false,
    accessor: "workloadVarCounty",
    formatter: (x) => workloadPerc(x, "county"),
  },
];

export const COUNTY_CLASSES_POP = {
  "1": {
    displayLabel: "First Class",
    popMin: 1500000,
    popMax: null,
  },
  "2": {
    displayLabel: "Second Class",
    popMin: 800000,
    popMax: 1499999,
  },
  "2-A": {
    displayLabel: "Second Class A",
    popMin: 500000,
    popMax: 799999,
  },
  "3": {
    displayLabel: "Third Class",
    popMin: 210000,
    popMax: 499999,
  },
  "4": {
    displayLabel: "Fourth Class",
    popMin: 145000,
    popMax: 209999,
  },
  "5": {
    displayLabel: "Fifth Class",
    popMin: 90000,
    popMax: 144999,
  },
  "6": {
    displayLabel: "Sixth Class",
    popMin: 45000,
    popMax: 89999,
  },
  "7": {
    displayLabel: "Seventh Class",
    popMin: 20000,
    popMax: 44999,
  },
  "8": {
    displayLabel: "Eighth Class",
    popMin: 0,
    popMax: 19999,
  },
};
